import { render, staticRenderFns } from "./SafeDigIndianaPage.vue?vue&type=template&id=80c50784&scoped=true"
import script from "./SafeDigIndianaPage.vue?vue&type=script&lang=js"
export * from "./SafeDigIndianaPage.vue?vue&type=script&lang=js"
import style0 from "./SafeDigIndianaPage.vue?vue&type=style&index=0&id=80c50784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c50784",
  null
  
)

export default component.exports